export const CustomMetricKeys: any = {
	duration: 'metric:duration',
	durationHistograms: 'metric:duration:histogramBuckets',
};
